'use client';

import { usePathname } from '@/i18n/routing';
import { useEffect, useState } from 'react';
import { useContext } from 'react';
import { ReportContext } from '@/app/providers/reportProvider';
import { useLocale, useTranslations } from 'use-intl';
import dynamic from 'next/dynamic';
const BuyButton = dynamic(() => import('./buy-now-btn'));
const SampleButton = dynamic(() => import('./sample-button'));
const NavTitlebar = dynamic(() => import('./nav-titlebar'));
const LeadMagnet = dynamic(() =>
  import('@/components/report-page/lead_magnet/lead-magnet')
);
const RedirectPopUp = dynamic(() =>
  import('@/components/report-page/redirectPopUp')
);
import './report-title-section.css';

export default function ReportTitleBanner() {
  const pathName = usePathname();
  const report = useContext(ReportContext);
  const banner = useTranslations('titlebanner');
  const snapshots = useTranslations('snapshots');
  const locale = useLocale();

  const [pageTitle, setPageTitle] = useState(
    `${report.keyword} ${
      banner('title') ||
      'SIZE AND SHARE ANALYSIS - GROWTH TRENDS AND FORECASTS '
    } (${report.studyperiod || '2024-2031'})`
  );
  const [isOpen, setIsOpen] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    setPageTitle(pageTitle);
  }, [pathName, report]); //eslint-disable-line

  function handleScroll() {
    if (window.scrollY >= 333) {
      setShow(true);
    } else {
      setShow(false);
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  //Pop-Up Timing
  useEffect(() => {
    setTimeout(() => setIsOpen(true), 1 * 90000);
  }, []);

  const newsSubjectForMobile = report.newsSubject.substring(0, 100);

  return (
    <div className="head-section" id="title-banner">
      {isOpen && <LeadMagnet isOpen={isOpen} setIsOpen={setIsOpen} />}
      {locale !== 'en' && <RedirectPopUp />}
      <NavTitlebar regionalText={banner} pageTitle={pageTitle} show={show} />
      <div className="container-mobile lg:container">
        <div className="report-heading">
          <h1 className="report-title">{pageTitle}</h1>
        </div>
        <div className="lg:grid lg:grid-cols-3 lg:gap-y-4">
          <div className="col-span-2 report-heading">
            <p className="short-description hidden lg:block text-left lg:text-justify">
              {report.newsSubject}
            </p>
            <p className="short-description lg:hidden text-left lg:text-justify">
              {newsSubjectForMobile}...
            </p>
          </div>
          <div className="col-span-1 flex justify-end px-2 pb-2 mt-3">
            <div className="w-full my-auto ms-3">
              <BuyButton text={banner('buynow')} />
              <SampleButton
                className="btn btn-download rounded-lg"
                text={banner('sample_text')}
              >
                {banner('sample_text')}
              </SampleButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
